/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Shared_BadgeInputs */

const es_chat_shared_badge = /** @type {(inputs: Chat_Shared_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat compartido`)
};

const en_chat_shared_badge = /** @type {(inputs: Chat_Shared_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared chat`)
};

/**
* | output |
* | --- |
* | "Shared chat" |
*
* @param {Chat_Shared_BadgeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_shared_badge = /** @type {((inputs?: Chat_Shared_BadgeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Shared_BadgeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_shared_badge(inputs)
	return en_chat_shared_badge(inputs)
});
export { chat_shared_badge as "chat.shared.badge" }